<template>
    <div>
        <CRow class="d-flex">
            <CCol sm="5" class="d-flex align-items-stretch p-1">
                <CCard class="p-3 border-16px">
                    <h3 class="custom-20px-500">Summary Reports</h3>
                    <CRow class="mt-3">
                        <CCol sm="6">
                            <CCard class="bg-26224E p-20 border-16px p-2">
                                <div class="m-2">
                                    <img src="../assets/img/all/note.png" width="20px" />
                                    <h3 class="custom-16px-500 text-white text-left mt-2">Total Reports</h3>
                                    <h4 class="custom-24px-600 mt-2 text-white">{{ reportCount.toLocaleString() }}</h4>
                                </div>
                            </CCard>
    
                        </CCol>
                        <CCol sm="6">
                            <CCard class="p-20 border-16px p-2">
                                <div class="m-2">
                                    <img src="../assets/img/all/under.png" width="20px" />
                                    <h3 class="custom-16px-500 text-left mt-2">Under Investigation</h3>
                                    <h4 class="custom-24px-600 mt-2">0</h4>
                                </div>
                            </CCard>
                        </CCol>
                        <CCol sm="6">
                            <CCard class="p-20 border-16px p-2">
                                <div class="m-2">
                                    <img src="../assets/img/all/emergency.png" width="20px" />
                                    <h3 class="custom-16px-500 text-left mt-2">New Reports</h3>
                                    <h4 class="custom-24px-600 mt-2">0</h4>
                                </div>
                            </CCard>
    
                        </CCol>
                        <CCol sm="6">
                            <CCard class="p-20 border-16px p-2">
                                <div class="m-2">
                                    <img src="../assets/img/all/closed.png" width="20px" />
                                    <h3 class="custom-16px-500 text-left mt-2">Closed Reports</h3>
                                    <h4 class="custom-24px-600 mt-2">0</h4>
                                </div>
                            </CCard>
                        </CCol>
                    </CRow>
                </CCard>
            </CCol>
            <CCol sm="7" class="d-flex align-items-stretch p-1">
                <CCard class="p-3 border-16px w-100">
                    <h3 class="custom-20px-500">Incident Map</h3>
                    <br />
                    <div class="map-wrapper map-container">
                        <l-map v-if="isMapLoaded" :zoom="zoom" :center="center" style="width: 100%">
                            <l-tile-layer :url="tileLayerUrl" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="markerPosition">
                                <l-popup>This is the selected location!</l-popup>
                            </l-marker>
                        </l-map>
                    </div>
                </CCard>
            </CCol>
        </CRow>
        <CRow class="d-flex">
            <CCol sm="8" class="p-0">
                <CCard class="p-2 border-16px">
                    <h3 class="custom-20px-500">Recent Reports List</h3>
                    <table class="table table-responsive-sm mt-3">
                        <thead class="custom-E9E9ED p-4">
                            <th>
                                <h3 class="custom-14px-500">Report No</h3>
                            </th>
                            <th>
                                <h3 class="custom-14px-500">Date</h3>
                            </th>
                            <!-- <th>
                                <h3 class="custom-14px-500">Time</h3>
                            </th> -->
                            <th>
                                <h3 class="custom-14px-500">Name</h3>
                            </th>
                            <th>
                                <h3 class="custom-14px-500">Type</h3>
                            </th>
                            <th>
                                <h3 class="custom-14px-500">Location</h3>
                            </th>
                            <th>
                                <h3 class="custom-14px-500">Status</h3>
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="item in reports" v-bind:key="item.ReportId">
                                <td>
                                    <h3 class="custom-14px-500 d-flex">{{ item.ReportId }}</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500 d-flex"><img src="../assets/img/smallicon/calendar-small.png" height="15px" class="mr-2" />{{ item.ReportDate | moment("DD/MM/YYYY") }}</h3>
                                </td>
                                <!-- <td>
                                    <h3 class="custom-14px-500">{{ item.ReportTime }}</h3>
                                </td> -->
                                <td>
                                    <h3 class="custom-14px-500">{{ item.FullName }}</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500"></h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">{{ item.Locations }}</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">
                                        <label class="custom-bg-new" style="display: flex; align-items: center; gap: 5px;">
                                            <img src="../assets/img/smallicon/circle-new.svg" width="10px"/>
                                            <span class="font-color-039855">New</span>
                                        </label>
                                    </h3>
                                </td>
                            </tr>
                            <!-- <tr>
                                <td>
                                    <h3 class="custom-14px-500">RP-20250213-001</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500"><img src="../assets/img/smallicon/calendar-small.png" width="15px" class="mr-2" />12/11/2024</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">04:40 AM</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">John Smith</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">Theft</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">78 Elm St</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">
                                        <label class="custom-bg-progress">
                                                    <img src="../assets/img/smallicon/circle-progress.svg" width="10px"/> <span class="ml-2 font-color-FC7D5D">In Progress</span>
                                                </label>
                                    </h3>
                                </td>
                            </tr> -->
                           
                        </tbody>
                    </table>
                </CCard>
            </CCol>
            <CCol sm="4">
                <CCard class="p-3 border-16px">
                    <h3 class="custom-20px-500">Crime Analytics</h3>
                    <h3 class="custom-20px-400 font-color-171717">{{ activeMonthValue }}</h3>
                    <canvas id="customBarChart"></canvas>
    
    
                    <!-- <canvas id="canvas"></canvas> -->
                </CCard>
                <CCard class="p-3 border-16px">
                    <h3 class="custom-20px-500">Report Status</h3>
                    <h3 class="custom-20px-400 font-color-171717"></h3>
                    <CChartDoughnut :datasets="defaultDatasets" :labels="['Open Reports', 'Closed Reports']" />
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";

import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { CChartBar } from '@coreui/vue-chartjs'
import { CChartDoughnut } from '@coreui/vue-chartjs'

Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");


export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        CChartBar,
        CChartDoughnut
    },
    data() {
        return {
            checkpoints: [{ id: 1, lat: 2.9573051, long: 101.7922522 }],
            mapKey: 0,
            chartData: [],
            activeMonthValue: 0,

            isMapLoaded: false,
            zoom: 13,
            center: [3.139, 101.6869], // Kuala Lumpur (example)
            markerPosition: [3.139, 101.6869],
            tileLayerUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',

            reports: [],
            reportCount: 0



        };
    },
    computed: {
        defaultDatasets() {
            return [{
                backgroundColor: [
                    '#26224E',
                    '#A3A3A3',
                ],
                data: [40, 20]
            }]
        }
    },
    async mounted() {

        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
                this.isMapLoaded = true; // Ensures map loads properly
                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.$refs.mapInstance ?.mapObject) {
                            const map = this.$refs.mapInstance.mapObject;
                            map.invalidateSize();
                        }
                    }, 500); // Slightly longer delay for better rendering
                });
                this.GetMonthlyDatas();
                this.createBarChart();
                this.GetListReport();
                // await this.getListQuestion(this.index);
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

       
    },
    methods: {
        forceMapRedraw() {
            this.$nextTick(() => {
                if (this.$refs.mapInstance ?.mapObject) {
                    const map = this.$refs.mapInstance.mapObject;
                    map.invalidateSize(true);
                }
            });
        },
        createBarChart() {
            const canvas = document.getElementById('customBarChart');
            if (!canvas) {
                console.error("Canvas element with id 'customBarChart' not found.");
                return;
            }

            const ctx = canvas.getContext('2d');
            if (!ctx) {
                console.error("Unable to get context for 'customBarChart'.");
                return;
            }

            const gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
            gradient.addColorStop(0, '#26224E');
            gradient.addColorStop(1, '#26224E');

            const currentMonth = new Date().toLocaleString('default', { month: 'long' });

            // Get the last 4 months (handling year change)
            const today = new Date();
            const lastFourMonths = [];

            for (let i = 3; i >= 0; i--) {
                const d = new Date();
                d.setMonth(today.getMonth() - i);
                lastFourMonths.push({
                    month: d.toLocaleString('default', { month: 'long' }),
                    year: d.getFullYear()
                });
            }

            const normalizeMonth = (monthName) => {
                return monthName.charAt(0).toUpperCase() + monthName.slice(1).toLowerCase();
            };

            const labels = lastFourMonths.map(data => data.month);
            const values = lastFourMonths.map(data => {
                const found = this.chartData.find(entry =>
                    normalizeMonth(entry.month) === normalizeMonth(data.month)
                );
                return found ? found.value : 0;
            });

            if (values.length === 0) {
                console.error("Chart data is empty or mismatched. Ensure API returns correct data.");
                return;
            }

            if (this.chart) {
                this.chart.destroy();
            }

            this.chart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Monthly Values',
                        data: values,
                        backgroundColor: labels.map(month =>
                            month === currentMonth ? gradient : '#EAECF0'
                        ),
                        borderWidth: 1,
                        borderRadius: 50, // Set border radius for rounded corners
                        hoverBackgroundColor: '#1E1E1E', // Hover effect (optional)
                    }]
                },
                options: {
                    plugins: { tooltip: { enabled: true } },
                    scales: {
                        x: {
                            beginAtZero: true,
                            ticks: {
                                autoSkip: true,
                                maxRotation: 0,
                                color: '#1E1E1E' // Color of tick labels on the X-axis
                            },
                            grid: {
                                color: '#4E4E4E', // Color of the X-axis grid lines
                            },
                            axis: {
                                lineColor: '#1E1E1E', // Change the X-axis line color
                                lineWidth: 2, // Line thickness
                            }
                        },
                        y: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 1, // Adjust step size if needed
                                color: '#1E1E1E' // Color of tick labels on the Y-axis
                            },
                            grid: {
                                color: '#4E4E4E', // Color of the Y-axis grid lines
                            },
                            axis: {
                                lineColor: '#1E1E1E', // Change the Y-axis line color
                                lineWidth: 2, // Line thickness
                            }
                        }
                    }
                }
            });
        },
        // createBarChart() {
        //     const canvas = document.getElementById('customBarChart');
        //     if (!canvas) {
        //         console.error("Canvas element with id 'customBarChart' not found.");
        //         return;
        //     }

        //     const ctx = canvas.getContext('2d');
        //     if (!ctx) {
        //         console.error("Unable to get context for 'customBarChart'.");
        //         return;
        //     }

        //     const gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
        //     gradient.addColorStop(0, '#26224E');
        //     gradient.addColorStop(1, '#26224E');

        //     const currentMonth = new Date().toLocaleString('default', { month: 'long' });

        //     // Get the last 4 months (handling year change)
        //     const today = new Date();
        //     const lastFourMonths = [];

        //     for (let i = 3; i >= 0; i--) {
        //         const d = new Date();
        //         d.setMonth(today.getMonth() - i);
        //         lastFourMonths.push({
        //             month: d.toLocaleString('default', { month: 'long' }),
        //             year: d.getFullYear()
        //         });
        //     }

        //     const normalizeMonth = (monthName) => {
        //         return monthName.charAt(0).toUpperCase() + monthName.slice(1).toLowerCase();
        //     };

        //     const labels = lastFourMonths.map(data => data.month);
        //     const values = lastFourMonths.map(data => {
        //         const found = this.chartData.find(entry =>
        //             normalizeMonth(entry.month) === normalizeMonth(data.month)
        //         );
        //         return found ? found.value : 0;
        //     });

        //     if (values.length === 0) {
        //         console.error("Chart data is empty or mismatched. Ensure API returns correct data.");
        //         return;
        //     }

        //     if (this.chart) {
        //         this.chart.destroy();
        //     }

        //     this.chart = new Chart(ctx, {
        //         type: 'bar',
        //         data: {
        //             labels: labels,
        //             datasets: [{
        //                 label: 'Monthly Values',
        //                 data: values,
        //                 backgroundColor: labels.map(month =>
        //                     month === currentMonth ? gradient : '#EAECF0'
        //                 ),
        //                 borderWidth: 1,
        //                 borderRadius: 50,  // Set border radius for rounded corners
        //                 hoverBackgroundColor: '#1E1E1E',  // Hover effect (optional)
        //             }]
        //         },
        //         options: {
        //             plugins: { tooltip: { enabled: true } },
        //             scales: {
        //                 x: {
        //                     beginAtZero: true, 
        //                     ticks: { 
        //                         autoSkip: true, 
        //                         maxRotation: 0,
        //                         color: '#1E1E1E'  // Color of tick labels on the X-axis
        //                     },
        //                     grid: {
        //                         color: '#4E4E4E', // Color of the X-axis grid lines
        //                     },
        //                     axis: {
        //                         lineColor: '#1E1E1E', // Change the X-axis line color
        //                         lineWidth: 2,  // Line thickness
        //                     }
        //                 },
        //                 y: {
        //                     beginAtZero: true,
        //                     ticks: { 
        //                         stepSize: 1,  // Adjust step size if needed
        //                         color: '#1E1E1E'  // Color of tick labels on the Y-axis
        //                     },
        //                     grid: {
        //                         color: '#4E4E4E', // Color of the Y-axis grid lines
        //                     },
        //                     axis: {
        //                         lineColor: '#1E1E1E', // Change the Y-axis line color
        //                         lineWidth: 2,  // Line thickness
        //                     }
        //                 }
        //             }
        //         }
        //     });
        // },
        async GetMonthlyDatas() {
            try {
                const response = await this.$API.get(this.$GetMonthlyChartData);
                if (response.status === 200) {
                    this.chartData = response.data;
                    const currentMonth = new Date().toLocaleString('default', { month: 'long' });

                    // Find the value for the current month
                    const found = this.chartData.find(entry =>
                        entry.month.toLowerCase() === currentMonth.toLowerCase()
                    );

                    // Set the active month value (default to 0 if not found)
                    this.activeMonthValue = found ? found.value : 0;

                    // Call createBarChart after chartData is populated
                    if (this.chart) {
                        this.chart.destroy(); // Destroy the existing chart
                    }
                    this.createBarChart();
                } else {
                    console.error("Failed to fetch monthly chart data:", response);
                }
            } catch (error) {
                console.error("Error fetching monthly chart data:", error);
            }
        },
        GetListReport() {
            try {

                return this.$API
                .get(this.$GetAllReportDetails, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.reports = response.data;
                        this.reportCount = this.reports.length;
                    }
                });
            } catch (error) {
                console.log("eroor1" + response);
            }
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
    }
};
</script>

<style scoped>
/* Ensures the card contains the map properly */

.map-container {
    position: relative;
    height: 250px;
    overflow: hidden;
}

/* Ensures the map wrapper fills its parent */

.map-wrapper {
    position: relative;
    width: 100%;
    height: 250px;
}

/* Forces Leaflet map to fully fit inside */

.full-map {
    width: 100%;
    height: 250px;
}

.leaflet-container {
    width: 100% !important;
    height: 100% !important;
    min-height: 250px;
    display: block;
}

.map-wrapper {
    width: 100%;
    /* Ensure full width */
    height: 100%;
    /* Ensure full height */
    display: flex;
}

.map-container {
    flex-grow: 1;
    /* Allow map to take available space */
    width: 100%;
    /* Adjust height as needed */
}
</style>